import React from 'react'
import { useTranslation } from 'react-i18next'

import { AccessControl, AccessControlNoRights, FormProgress, FormTitle } from '../../../../components'
import { userRightTypes } from '../../../../constants'
import { Logger, LoggerTypes } from '../../../../utils'
import { ProjectForm } from './ProjectForm'
import './style.scss'

export const ProjectCreate = () => {
  const { t } = useTranslation()
  const steps = ['About the project', 'Initial library setup']

  Logger.trace(LoggerTypes.CONTROLLER, 'ProjectCreate.render()')

  return (
    <div className="ProjectCreate">
      <FormTitle title={t('projects.create.title')} />
      <FormProgress steps={steps} />

      <AccessControl userPermissions={[userRightTypes.PROJECT_EDIT]} renderNoAccess={() => <AccessControlNoRights />}>
        <ProjectForm />
      </AccessControl>
    </div>
  )
}
